/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetAutoShipChurnPreventionOfferQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetAutoShipChurnPreventionOfferQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    autoShipChurnPreventionOfferModule?: {
      __typename?: "AutoShipChurnPreventionOfferModule";
      acceptCtaLabel: string;
      acceptProductTrackingEventActionName: string;
      acceptProductTrackingEventName: string;
      declineCtaLabel: string;
      declineProductTrackingEventActionName: string;
      declineProductTrackingEventName: string;
      description: string;
      headline: string;
      name: Types.ModuleName;
      offerId: string;
      productTrackingEventName: string;
    } | null;
  } | null;
};

export const GetAutoShipChurnPreventionOfferDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAutoShipChurnPreventionOffer" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "autoShipChurnPreventionOfferModule" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "acceptCtaLabel" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "acceptProductTrackingEventActionName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "acceptProductTrackingEventName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "declineCtaLabel" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "declineProductTrackingEventActionName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "declineProductTrackingEventName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "headline" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "offerId" } },
                      { kind: "Field", name: { kind: "Name", value: "productTrackingEventName" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAutoShipChurnPreventionOfferQuery__
 *
 * To run a query within a React component, call `useGetAutoShipChurnPreventionOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoShipChurnPreventionOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoShipChurnPreventionOfferQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutoShipChurnPreventionOfferQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAutoShipChurnPreventionOfferQuery,
    GetAutoShipChurnPreventionOfferQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAutoShipChurnPreventionOfferQuery,
    GetAutoShipChurnPreventionOfferQueryVariables
  >(GetAutoShipChurnPreventionOfferDocument, options);
}
export function useGetAutoShipChurnPreventionOfferLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAutoShipChurnPreventionOfferQuery,
    GetAutoShipChurnPreventionOfferQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAutoShipChurnPreventionOfferQuery,
    GetAutoShipChurnPreventionOfferQueryVariables
  >(GetAutoShipChurnPreventionOfferDocument, options);
}
// @ts-ignore
export function useGetAutoShipChurnPreventionOfferSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAutoShipChurnPreventionOfferQuery,
    GetAutoShipChurnPreventionOfferQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAutoShipChurnPreventionOfferQuery,
  GetAutoShipChurnPreventionOfferQueryVariables
>;
export function useGetAutoShipChurnPreventionOfferSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAutoShipChurnPreventionOfferQuery,
        GetAutoShipChurnPreventionOfferQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAutoShipChurnPreventionOfferQuery | undefined,
  GetAutoShipChurnPreventionOfferQueryVariables
>;
export function useGetAutoShipChurnPreventionOfferSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAutoShipChurnPreventionOfferQuery,
        GetAutoShipChurnPreventionOfferQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAutoShipChurnPreventionOfferQuery,
    GetAutoShipChurnPreventionOfferQueryVariables
  >(GetAutoShipChurnPreventionOfferDocument, options);
}
export type GetAutoShipChurnPreventionOfferQueryHookResult = ReturnType<
  typeof useGetAutoShipChurnPreventionOfferQuery
>;
export type GetAutoShipChurnPreventionOfferLazyQueryHookResult = ReturnType<
  typeof useGetAutoShipChurnPreventionOfferLazyQuery
>;
export type GetAutoShipChurnPreventionOfferSuspenseQueryHookResult = ReturnType<
  typeof useGetAutoShipChurnPreventionOfferSuspenseQuery
>;
export type GetAutoShipChurnPreventionOfferQueryResult = Apollo.QueryResult<
  GetAutoShipChurnPreventionOfferQuery,
  GetAutoShipChurnPreventionOfferQueryVariables
>;
